<template>
    <v-container fluid>
        <!-- <div class="d-flex justify-left mt-2">
          <v-subheader class="headline font-weight-bold">Enquiries</v-subheader>
        </div> -->
        <v-card>
          <v-row>
            <v-col cols="12" md="12" lg="12" xs="12" sm="12">
              <div class="d-flex justify-left">
                <v-subheader class="headline font-weight-bold">Enquiries</v-subheader>
              </div>
            </v-col>
            <v-col class="pt-0" cols="12" md="12" lg="12" xs="12" sm="12">
              <v-card-text class="py-0">
                <form @submit.prevent="filterSpancoListOnFilterBasis">
                  <v-row class="mt-4">
                    <v-col cols="12" md="3" lg="3" sm="6" xs="12">
                      <label class="font-weight-medium body-2">
                        Start Date <span class="red--text">*</span>
                      </label>
                      <custom-date-picker
                        label="From"
                        dense
                        prepend-icon="mdi-calendar"
                        :maxToDate="filter.toDate"
                        v-model="filter.fromDate"
                        required
                      />
                    </v-col>
                    <v-col cols="12" md="3" lg="3" sm="6" xs="12">
                      <label class="font-weight-medium body-2">
                        End Date <span class="red--text">*</span>
                      </label>
                      <custom-date-picker
                        label="To"
                        dense
                        prepend-icon="mdi-calendar"
                        :minToDate="filter.fromDate"
                        v-model="filter.toDate"
                        required
                      />
                    </v-col>
                    <v-col v-if="sourceCardAccess" cols="12" md="3" lg="3" sm="6" xs="12">
                      <label class="font-weight-medium body-2">
                        Source
                      </label>
                      <v-autocomplete
                        style="margin-top:-3px;"
                        class="pt-0"
                        :items="sourceCategoryData"
                        v-model="sourceCard"
                        hide-details
                        item-text="name"
                        item-value="name"
                        placeholder="Filter By Source"
                      />
                    </v-col>
                    <v-col cols="12" md="3" lg="3" sm="6" xs="12">
                      <v-switch
                        v-model="followUpOnly"
                        label="FollowUp-Only"
                        color="primary"
                      />
                    </v-col>
                    <v-col
                      v-if="!$vuetify.breakpoint.xs"
                      cols="12"
                      md="12"
                      lg="12"
                      sm="12"
                      xs="12"
                    >
                      <v-card-actions class="justify-center">
                        <v-btn
                          color="#5d58ef"
                          class="white--text"
                          small
                          type="submit"
                        >
                          <v-icon left>mdi-filter</v-icon>Apply Filter
                        </v-btn>
                        <v-btn @click="resetFilter" depressed small>
                          <v-icon left> mdi-restart</v-icon> Reset Filter
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                    <v-col v-else cols="12" xs="12" class="px-0">
                      <v-row no-gutters>
                        <v-col class="mb-2" cols="12" xs="12">
                          <v-btn
                            color="#5d58ef"
                            class="white--text"
                            dense
                            style="min-width: 100%"
                            type="submit"
                          >
                            <v-icon left>mdi-filter</v-icon>Apply Filter
                          </v-btn>
                        </v-col>
                        <v-col cols="12" xs="12">
                          <v-btn
                            depressed
                            dense
                            style="min-width: 100%"
                            @click="resetFilter"
                          >
                            <v-icon left> mdi-restart</v-icon> Reset Filter
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </form>
              </v-card-text>
            </v-col>
            <v-col class="px-6" cols="12" md="12" lg="12" sm="12">
              <div class="spanco-block">
                <div class="spanco-inner-block">
                  <template v-if="skeletonLoaderFlag">
                    <div
                      class="spanco-inner-row pa-2"
                      v-for="(i,index) in 8"
                      :key="`${index}_skeleton`"
                    >
                      <v-skeleton-loader
                        class="custom_skeleton_item"
                        type="list-item-two-line"
                      ></v-skeleton-loader>
                      <v-skeleton-loader
                        v-for="(j,jindex) in 8"
                        :key="`${jindex}_image_skeleton`"
                        class="custom_skeleton_item my-2"
                        height="100"
                        type="image"
                      ></v-skeleton-loader>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="spanco-inner-row pa-2"
                      v-for="(item, spancoStatus) in reportData"
                      :key="spancoStatus"
                    >
                      <div v-if="spancoStatus != 'Total'">
                        <template>
                            <v-card-subtitle
                              class="pb-0 pl-0 pt-0 mb-2"
                            >
                              <div style="cursor: pointer;">
                                <div @click="redirectToEnquiryListing(spancoStatus)">
                                  <span style="color:rgba(0,0,0,.87)!important;" class="font-weight-medium body-1">{{ item[0] }}</span>
                                  <span style="color:rgba(0,0,0,.87)!important;">- {{ spancoStatus }}</span>
                                  <v-spacer></v-spacer>
                                  <span style="color:rgba(0,0,0,.87)!important;font-size: 12px">
                                      Today's Enquiry :<span class="font-weight-medium body-2">{{ item[1] }}</span>
                                  </span>
                                </div>
                              </div>
                            </v-card-subtitle>
                        </template>
                      </div>
                      <template v-for="(item1, key1) in item">
                        <div class="custom-card-block mt-2" v-if="item1.stagename" :key="key1">
                          <v-card
                            @click="redirectToEnquiryListing(spancoStatus, capitalizeFirstLetter(item1.stagename))"
                            color="orange"
                            class="rounded-lg mx-auto pl-1"
                            elevation="2"
                            dark
                          >
                            <div style="background-color:white; min-width:200px; height:90px;">
                              <v-card-title v-if="item1.cnt" class="py-1 mb-3 text-h5 black--text" v-text="item1.cnt" />
                              <v-card-subtitle v-if="item1.cnt" class="secondary--text body-2" v-text="item1.stagename" />
                            </div>
                          </v-card>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
    </v-container>
</template>
<script>
import CustomDatePicker from '@/components/template/CustomDatePicker'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import Stores from '@/stores'
import _ from 'lodash'
export default {
  name: 'enquiry-dashboard',
  components: {
    CustomDatePicker
  },
  data () {
    return {
      isActive: false,
      isActive2: false,
      academicYearID: '',
      reportData: [],
      franchiseeID: '',
      filter: {
        fromDate: null,
        toDate: null
      },
      maxToDate: null,
      sourceCard: '',
      sourceCategoryData: [
        { id: 1, name: 'QR Leads' },
        { id: 2, name: 'WhatsApp Leads' },
        { id: 3, name: 'Manual Leads' },
        { id: 4, name: 'Facebook Leads' },
        { id: 5, name: 'Intelllitots Website Leads' }
      ],
      sourceCardAccess: false,
      followUpOnly: false,
      skeletonLoaderFlag: false
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.onFranchiseeChange()
      }
    },
    academicYear: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.onFranchiseeChange()
      }
    }
  },
  created: async function () {
    await this.onFranchiseeChange()
    this.sourceCardAccess = await this.checkModuleAccess('sourceCardAccess')
  },
  methods: {
    getFranchiseeDataFromIndexDB: function () {
      let obj = Stores.user.franchisee
      return obj
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    onFranchiseeChange: async function () {
      if (this.franchisee && this.franchisee.id) {
        this.franchiseeID = this.franchisee.id
      } else {
        let getFranchiseeData = this.getFranchiseeDataFromIndexDB()
        this.franchiseeID = (getFranchiseeData && getFranchiseeData.id) ? getFranchiseeData.id : ''
      }
      if (this.academicYear) {
        this.academicYearID = this.academicYear.id
      } else {
        this.academicYearID = ''
      }
      if (!this.franchiseeID) {
        Utils.helper.openDrawer(this)
      } else {
        Utils.helper.openDrawer(this, false)
      }
      if (this.academicYearID) {
        await this.getEnquiryStagesReport()
      }
    },
    getEnquiryStagesReport: async function () {
      try {
        this.skeletonLoaderFlag = true
        if (this.academicYearID) {
          const formData = {
            academicYearID: this.academicYearID
          }
          if (this.franchiseeID) {
            formData.franchiseeID = this.franchiseeID
          } else {
            formData.franchiseeID = ''
          }
          if (this.isApplyFilter) {
            if (_.isEmpty(this.filter.fromDate) || _.isNull(this.filter.fromDate)) {
              this.errMsg('Please select start date.')
            } else if (_.isEmpty(this.filter.toDate) || _.isNull(this.filter.toDate)) {
              this.errMsg('Please select end date.')
            }
            formData.fromDate = this.filter.fromDate
            formData.toDate = this.filter.toDate
            if (this.sourceCard) {
              formData.sourceName = this.sourceCard
            }
            formData.followUpOnly = this.followUpOnly
          }
          const { data } = await http.post(
            `${constants.API_URL}/api/enquirystages-report`,
            formData
          )
          this.reportData = data
          this.skeletonLoaderFlag = false
        }
      } finally {
        this.isLoading = false
        this.skeletonLoaderFlag = false
      }
    },
    redirectToEnquiryListing: async function (spancoStatus = '', spancoName = '') {
      let routerData = {}
      if (spancoStatus && spancoName) {
        routerData = this.$router.resolve({ name: 'enquiryList' })
      } else {
        routerData = this.$router.resolve({ name: 'enquiryList' })
      }
      localStorage.setItem(
        'dashboardEnquiryFilter',
        JSON.stringify({
          isApplyFilter: this.isApplyFilter ? this.isApplyFilter : false,
          spancoStatus: spancoStatus,
          spancoName: spancoName,
          fromDate: this.filter.fromDate,
          toDate: this.filter.toDate,
          sourceName: this.sourceCard,
          followUpOnly: this.followUpOnly
        })
      )
      window.open(routerData.href, '_blank')
    },
    filterSpancoListOnFilterBasis: async function () {
      try {
        this.isApplyFilter = true
        await this.getEnquiryStagesReport()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(errorMessage)
      }
    },
    capitalizeFirstLetter: function (word) {
      if (word === 'Yet_to_Call') {
        let yetToCall = word.toLowerCase()
        return yetToCall.charAt(0).toUpperCase() + yetToCall.slice(1)
      }
      return word
    },
    resetFilter: function () {
      this.isApplyFilter = false
      if (localStorage.getItem('dashboardEnquiryFilter')) {
        localStorage.removeItem('dashboardEnquiryFilter')
      }
      this.filter.fromDate = null
      this.filter.toDate = null
      this.sourceCard = ''
      this.followUpOnly = false
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style scoped>
.spanco-block{
  width:100%;
  height:auto;
  overflow: hidden;
  overflow-x:auto;
}
.spanco-inner-block{
  width:2100px;
  height:auto;
  overflow:hidden;
}
.spanco-inner-row{
  width:15em;
  height:auto;
  overflow:hidden;
  float:left;
  margin-right:1em;
}
.custom-card-block{
    width:100%;
}
</style>
